import { useEffect } from "react";
import { Link } from "react-router-dom";
import { featuredTours } from "../data/site";
import "./page.css";
import "./home.css";

function Tours() {
  useEffect(() => {
    document.title = "Tours · Mirrorkhan Tours";
  }, []);

  return (
    <section className="page section-block">
      <div className="container">
        <div className="row mb-4 mb-lg-5" data-reveal>
          <div className="col-lg-8">
            <p className="eyebrow">Tours</p>
            <h1 className="mb-3">Zanzibar tours, and Tanzania beyond.</h1>
            <p className="page-lead mb-0">
              Small group trips focused on Zanzibar, with optional safari days
              on the mainland. Ask for dates that are actually open.
            </p>
          </div>
        </div>

        <div className="row g-4">
          {featuredTours.map((tour, index) => (
            <div
              className="col-12"
              key={tour.id}
              data-reveal
              style={{ "--reveal-delay": `${index * 80}ms` }}
            >
              <Link
                to={`/tours/${tour.id}`}
                className="tour-list-item row g-0 align-items-stretch text-decoration-none"
              >
                <div className="col-md-4 col-lg-3">
                  <img
                    src={tour.image}
                    alt={tour.imageAlt}
                    className="tour-list-item__image"
                    loading="lazy"
                  />
                </div>
                <div className="col-md-8 col-lg-9 d-flex">
                  <div className="tour-list-item__body">
                    <h2 className="h3 mb-2">{tour.title}</h2>
                    <p className="tour-list-item__meta mb-2">
                      {tour.days} days · {tour.place}
                    </p>
                    <p className="mb-0">{tour.summary}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Tours;
